import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  label: {
    display: 'flex',
    alignItems: 'center'
  },

  faded: {
    opacity: '0.4'
  },

  name: {
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer')
  }
}))

export default useStyles
